<template>
    <div v-show="logueado" id="miperfil" class="container bg-white br-2-blue">
        <form @submit.prevent="submit" class="pt-4">
            <h2 class="text-center">Mi Perfil</h2>
            <p class="text-center text-danger font-weight-bold">Todos los campos (*) son obligatorios</p>
            <div class="separador">
                <div class="form-row">
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Cuenta:</label>
                        <span v-if="tipo_de_cuenta_id == 1">&nbsp;Personal</span>
                        <span v-else>&nbsp;Empresarial</span>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Número de identificación *</label>
                        <input name="numero_de_identificacion" v-model="userData.numero_de_identificacion" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('numero_de_identificacion') }" class="form-control" placeholder="Nit o numero de identificacion *"
                            type="text" />
                        <span v-show="errors.has('numero_de_identificacion')" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Nombre *</label>
                        <input name="primer_nombre" v-model="userData.primer_nombre" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('primer_nombre') }" class="form-control" placeholder="Primer nombre *" type="text" />
                        <span v-show="errors.has('primer_nombre')" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Apellidos *</label>
                        <input name="apellidos" v-model="userData.apellidos" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('apellidos') }" class="form-control" placeholder="Apellidos *" type="text" />
                        <span v-show="errors.has('apellidos')" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 col-lg-4">
                        <label>País *</label>
                        <select class="form-control" v-model="selectPais" v-on:change="getEstados(selectPais)" name="ePais" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('ePais') }">
                          <option v-for="pais in paises" :key="pais.codigo" :value="pais.codigo">{{pais.nombre}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Departamento *</label>
                        <select class="form-control" v-model="selectEstado" v-on:change="getCiudades(selectEstado)" name="eEstado" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('eEstado') }">
                          <option
                            v-for="estado in estados"
                            :key="estado.id"
                            :value="estado.id"
                          >{{estado.nombre}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Ciudad *</label>
                        <select class="form-control" v-model="selectCiudad" name="eCiudad" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('eCiudad') }">
                          <option
                            v-for="ciudad in ciudades"
                            :key="ciudad.id"
                            :value="ciudad.id"
                          >{{ciudad.nombre}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Dirección *</label>
                        <input name="direccion" v-model="userData.direccion" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('direccion') }" class="form-control" placeholder="Dirección*" type="text" />
                        <span v-show="errors.has('direccion')" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 col-lg-4">
                        <label class="mt-1 mb-0 ml-1">Teléfono celular *</label>
                        <input name="telefono_celular" v-model="userData.telefono_celular" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('telefono_celular') }" class="form-control" placeholder="Teléfono celular *" type="text" />
                        <span v-show="errors.has('telefono_celular')" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Télefono fijo</label>
                        <input name="telefono_fijo" v-model="userData.telefono_fijo" class="form-control" placeholder="Teléfono fijo" type="text" />
                    </div>
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Género *</label>
                        <select class="form-control" v-model="userData.genero_id" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('genero_id') }" name="genero_id">
                          <option selected="selected" value>Género</option>
                          <option value="1">Masculino</option>
                          <option value="2">Femenino</option>
                        </select>
                        <span v-show="errors.has('genero_id')" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                </div>
    
                <div class="form-row">
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Email *</label>
                        <input class="form-control" v-validate="'required'" v-model="userData.email" name="email" type="email" :class="{'is-danger': errors.has('email')}" placeholder="Email" ref="email" />
                        <span v-show="errors.has('email')" class="small help text-danger">No es un email válido</span>
                    </div>
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Confirmación email *</label>
                        <input class="form-control" v-validate="'required|confirmed:email'" v-model="confirmarEmail" name="email_confirmation" type="email" :class="{'is-danger': errors.has('email_confirmation')}" placeholder="Confirmar email" data-vv-as="email" />
                        <span v-show="errors.has('email_confirmation')" class="small help text-danger">El email no coincide</span>
                    </div>
                    <div class="form-group col-md-4 col-lg-4">
                        <label>Fecha nacimiento</label>
                        <input class="form-control" v-model="userData.fecha_de_nacimiento" name="fecha_de_nacimiento" type="date" placeholder="Fecha nacimiento"/>
                    </div>
                </div>
    
                <div class="form-row">
                    <div class="form-group col-md-4"></div>
                    <div class="form-group col-md-4">
                        <button class="btn btn-lg btn-block btn-blue">Actualizar datos</button>
                    </div>
                    <div class="form-group col-md-4"></div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { getSelectedEnvironment, api } from "../plugins/api_conect";
const currentEnvironment = getSelectedEnvironment();
export default {
    computed: {
        logueado() {
            return this.$store.getters.loggedIn;
        }
    },
    methods: {
        buscarCodigo() {
            this.responseMessage = "Espere un momento...";
            this.showModal = true;
            api().get(`/api/casillero/codigospostales/${this.codigo_postal}/${this.selectPais}`, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                    }
                })
                .then((response) => {
                    const { data } = response;
                    const indexPais = this.paises.findIndex(
                        x => x.codigo === data["datos"]["pais"][0]["codigo"]
                    );
                    this.selectPais = this.paises[indexPais].codigo;

                    this.getEstados(this.selectPais);

                    const indexEstado = this.estados.findIndex(
                        x => x.id === data["datos"]["dpto"]["id"]
                    );
                    this.selectEstado = this.estados[indexEstado].id;

                    const indexCiudad = this.ciudades.findIndex(
                        x => x.id === data["datos"]["ciudad"]["id"]
                    );
                    this.selectCiudad = this.ciudades[indexCiudad].id;

                    this.userData.codigo_postal_id = data["datos"]["postal"][0]["id"];

                    this.buscarPostal = true;
                }).catch(async (error) => {
                    this.checked = true;
                    if (error.response && error.response.status === 400) {
                        this.$swal("Error", "Este codigo postal no esta en este pais", "error");
                    } else if (error.response && error.response.status === 401) {
                        try {
                            await this.$auth.refreshToken();
                            this.buscarCodigo();
                        } catch (error) {
                            this.$swal("Error", error, "error");
                        }

                    } else {
                        if (error.response)
                            this.$swal("Error", error.response.data.message, "error");
                    }
                });
        },
        loadData() {
            try {
              const datosCliente = JSON.parse(localStorage.getItem("datosCliente"));
              if (!datosCliente) throw new Error('No se encuentra informacion del cliente')

              this.tipo_de_cuenta_id = datosCliente["tipo_de_cuenta_id"];
              this.userData.primer_nombre = datosCliente["primer_nombre"];
              this.userData.primer_apellido = datosCliente["primer_apellido"];
              this.userData.numero_de_identificacion = datosCliente["numero_de_identificacion"];
              this.userData.barrio = datosCliente["barrio"] == null ? '' : datosCliente["barrio"];
              this.userData.email = datosCliente["email"];
              this.confirmarEmail = datosCliente["email"];
              this.userData.telefono_celular = datosCliente["telefono_celular"];
              this.userData.direccion = datosCliente["direccion"];
              this.pais = datosCliente["pais"];
              this.estado = datosCliente["departamento"];
              this.ciudad = datosCliente["ciudad"];
              this.userData.genero_id = datosCliente["genero_id"];
              this.userData.fecha_de_nacimiento = datosCliente['fecha_de_nacimiento'];

              if (datosCliente["segundo_nombre"] != null) {
                this.userData.segundo_nombre = datosCliente["segundo_nombre"];
              } else {
                this.userData.segundo_nombre = "";
              }
              if (datosCliente["segundo_apellido"] != null) {
                this.userData.segundo_apellido = datosCliente["segundo_apellido"];
              } else {
                this.userData.segundo_apellido = "";
              }

              this.userData.apellidos = String.prototype.concat(this.userData.primer_apellido, ' ', this.userData.segundo_apellido)
              if (datosCliente["telefono_fijo"] != null) {
                this.userData.telefono_fijo = datosCliente["telefono_fijo"];
              } else {
                this.userData.telefono_fijo = "";
              }
            }catch (err){
              this.$swal('¡ERROR!', `${err}`, 'error')
            }
        },
        getPaises: function() {
            api().get(`/api/casillero/clientes/getCountries/${currentEnvironment.app_id}`)
                .then((response) => {
                    const { data } = response;
                    this.paises = data;
                    if (this.pais) {
                        const indexPais = this.paises.findIndex(
                            x => x.codigo === this.pais.codigo
                        );
                        this.selectPais = this.paises[indexPais].codigo;
                        this.getEstados(this.selectPais);
                    }
                });
        },
        getEstados: function(codigoPais) {
            api().get(`/api/casillero/clientes/getDepartaments/${codigoPais}/${currentEnvironment.app_id}`)
                .then(response => {
                    const { data } = response;
                    if (data.length > 0) {
                        this.estados = data;

                        if (this.estado) {
                            const indexEstado = this.estados.findIndex(
                                x => x.id === this.estado.id
                            );
                            this.selectEstado = this.estados[indexEstado].id;
                            this.getCiudades(this.selectEstado);
                        }
                    } else {
                        this.selectEstado = "";
                        this.selectCiudad = "";
                    }
                });
        },
        getCiudades: function(idEstado) {
            api().get(`/api/casillero/clientes/getCities/${idEstado}/${currentEnvironment.app_id}`)
                .then(response => {
                    const { data } = response;
                    if (data.length > 0) {
                        this.ciudades = data;

                        if (this.estado && this.buscarPostal != true) {
                            const indexCiudad = this.ciudades.findIndex(
                                x => x.id === this.ciudad.id
                            );
                            this.selectCiudad = this.ciudades[indexCiudad].id;
                        }
                    } else {
                        this.selectCiudad = "";
                    }
                });
        },
        submit: function() {
            this.submitted = true;
            this.userData.apellidos = this.userData.apellidos.trim()
            this.userData.primer_apellido = this.userData.apellidos.split(' ')[0]?? '';
            this.userData.segundo_apellido = this.userData.apellidos.split(' ')[1]?? '';

            this.$validator.validate().then(valid => {
                if (valid) {
                    this.showModal = true;
                    let pais_codigo = this.selectPais ?? "";
                    let departamento_id = this.selectEstado ?? "";
                    let ciudad_id = this.selectCiudad ?? "";

                    let datos = this.userData;
                    datos["pais_codigo"] = pais_codigo;
                    datos["departamento_id"] = departamento_id;
                    datos["ciudad_id"] = ciudad_id;

                    api().post(`/api/casillero/miperfil`, datos, {
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                            },
                        })
                        .then(response => {
                            const { data } = response;
                            if (data["msg"] == "") {
                                this.$swal(
                                    "Proceso completado",
                                    "Su perfil fue actualizado exitosamente",
                                    "success"
                                );
                                data["datos"]["pais"] = this.pais;
                                data["datos"]["departamento"] = this.estado;
                                data["datos"]["ciudad"] = this.ciudad;
                                localStorage.setItem(
                                    "datosCliente",
                                    JSON.stringify(data["datos"])
                                );
                                this.loadData();
                            } else {
                                this.$swal("error", data["msg"], "error");
                            }
                            this.checked = true;
                        })
                        .catch((error) => {
                            if (error.response && error.response.status === 401) {
                                this.$auth.refreshToken();
                            }
                        });
                }
            });
        }
    },
    data() {
        return {
            suma: true,
            buscarPostal: false,
            submitted: false,
            showModal: false,
            responseMessage: "",
            checked: false,
            confirmarEmail: "",
            tipo_de_cuenta_id: 1,
            userData: {
                primer_nombre: "",
                segundo_nombre: "",
                primer_apellido: "",
                segundo_apellido: "",
                apellidos: "",
                tipo_de_identificacion_id: 1,
                numero_de_identificacion: "",
                email: "",
                telefono_celular: "",
                telefono_fijo: "",
                direccion: "",
                barrio: "",
                pais_codigo: "",
                departamento_id: "",
                ciudad_id: "",
                genero_id: "",
                codigo_postal_id: "",
                fecha_de_nacimiento: null
            },
            codigo_postal: "",
            paises: null,
            estados: null,
            ciudades: null,
            selectPais: null,
            selectEstado: null,
            selectCiudad: null,
            pais: null,
            estado: null,
            ciudad: null
        };
    },
    mounted: function() {
        this.loadData();
        this.getPaises();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#miperfil {
    margin-top: 25px;
    margin-bottom : 25px;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 4px;
    border-radius: 0.50rem;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
</style>